export interface PartnerLogoVariants {
  lightZh: string
  lightEn: string
  darkZh: string
  darkEn: string
}

export interface PartnerBranding {
  slug: string
  name: Record<'zh' | 'en', string>
  logo: {
    ai: PartnerLogoVariants
    cn: PartnerLogoVariants
  }
  communityQrCode?: string
  communityDescription?: Record<'zh' | 'en', string>
  supportEmail?: string
  hideSupportEmailLabel?: boolean
  footerDescription?: Record<'zh' | 'en', string>
  inviteDescription?: Record<'zh' | 'en', string>
}

export const PARTNER_BRANDING: Record<string, PartnerBranding> = {
  chaociyuan: {
    slug: 'chaociyuan',
    name: { zh: '潮词元', en: 'ChaoCiYuan' },
    logo: {
      ai: {
        lightZh: 'https://files.musein.ai/uploads/1787577623548-ohsl6r.png',
        lightEn: 'https://files.musein.ai/uploads/1787577621907-xnidcf.png',
        darkZh: 'https://files.musein.ai/uploads/1787577624038-let40c.png',
        darkEn: 'https://files.musein.ai/uploads/1787577622607-uu1mj2.png',
      },
      cn: {
        lightZh: 'https://files.musein.cn/images/1787755532495-0jv4oi.png',
        lightEn: 'https://files.musein.cn/images/1787755508124-8q8up8.png',
        darkZh: 'https://files.musein.cn/images/1787755543681-0rlsnt.png',
        darkEn: 'https://files.musein.cn/images/1787755514772-b8agh5.png',
      }
    },
    communityQrCode: 'https://files.musein.cn/images/1787647203496-l4mi95.jpg',
    communityDescription: {
      zh: '扫码加入潮词元 AIGC 微信交流社群，获取最新动态、交流创作经验。',
      en: 'Scan to join ChaoCiYuan AIGC WeChat community for the latest updates and creative discussions.',
    },
    supportEmail: 'tideTV@163.com',
    hideSupportEmailLabel: true,
    footerDescription: {
      zh: '潮词元AIGC视频创作平台是一款新颖的AI视觉创作引擎，深度融合Musein团队先进的视觉技术与传统影视制作流程。广泛适用于电商广告、电影感短片与实验艺术等场景，面向影视企业、专业创作者及大众用户，致力于帮助普通人借助AI技术轻松产出专业级影视内容。',
      en: 'ChaoCiYuan AIGC Video Creation Platform is an innovative AI visual creation engine that deeply integrates Musein\'s advanced visual technology with traditional film and video production workflows. Widely applicable to e-commerce advertising, cinematic shorts, and experimental art, it serves film enterprises, professional creators, and general users, dedicated to helping anyone produce professional-grade visual content with AI.',
    },
    inviteDescription: {
      zh: '邀请好友注册并使用 tideTV.musein.cn，您和好友都能获得积分奖励',
      en: 'Invite friends to register and use tideTV.musein.cn, both you and your friends will earn points.',
    },
  },
}

export function getPartnerBranding(slug: string | null): PartnerBranding | undefined {
  return slug ? PARTNER_BRANDING[slug] : undefined
}
